import { Status } from "../statusBadge.tsx";
import { ShipmentDocument } from "./ShipmentDocument.ts";
import { OrderLineItem } from "./OrderLineItem.ts";

export interface OrderShipment {
  sentBy?: string;
  status: Status;
  statusDate?: string;
  trackingUrl?: string;
  carrier?: string;
  orderLineItems: OrderLineItem[];
  document?: ShipmentDocument;
}

/**
 * Figures out if a shipment has been returned partially.
 * If all items have been returned, the status is just shown on shipment level.
 */
export function returnedPartially(shipment: OrderShipment): boolean {
  const totalReturned = shipment.orderLineItems.reduce(
    (acc, item) => acc + Number(item.quantityReturned),
    0,
  );
  const totalQuantity = shipment.orderLineItems.reduce(
    (acc, item) => acc + Number(item.quantity),
    0,
  );
  return totalReturned > 0 && totalReturned < totalQuantity;
}
